import React, { Component } from 'react';

class ErrorPage extends Component {
  render() {
    return <div>ErrorPage</div>;
  }
}

export default ErrorPage;
